import { motion } from "framer-motion";

const reveal = {
  hidden: { opacity: 0, y: 24 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] },
  }),
};

export const Reveal = ({ children, i = 0, className = "" }) => (
  <motion.div
    className={className}
    variants={reveal}
    custom={i}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-80px" }}
  >
    {children}
  </motion.div>
);

export const AppStoreButtons = ({ stores = {}, testidPrefix = "app", variant = "dark" }) => {
  const { ios, android } = stores;
  const btn =
    variant === "light"
      ? "bg-white text-navy hover:bg-white/90"
      : "bg-navy text-white hover:opacity-90";
  return (
    <div className="flex flex-wrap gap-3">
      {ios && (
        <a
          href={ios}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`${testidPrefix}-appstore-btn`}
          aria-label="Télécharger sur l'App Store"
          className={`group flex items-center gap-3 rounded-xl px-5 py-2.5 transition-opacity ${btn}`}
        >
          <svg viewBox="0 0 24 24" className="h-6 w-6 fill-current"><path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/></svg>
          <span className="text-left leading-none">
            <span className="block text-[10px] opacity-70">Télécharger sur</span>
            <span className="block text-sm font-semibold">App Store</span>
          </span>
        </a>
      )}
      {android && (
        <a
          href={android}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`${testidPrefix}-googleplay-btn`}
          aria-label="Disponible sur Google Play"
          className={`group flex items-center gap-3 rounded-xl px-5 py-2.5 transition-opacity ${btn}`}
        >
          <svg viewBox="0 0 24 24" className="h-6 w-6"><path fill="#EA4335" d="M3.6 2.4 13.3 12 3.6 21.6c-.4-.3-.6-.8-.6-1.4V3.8c0-.6.2-1.1.6-1.4z" opacity=".9"/><path fill="#FBBC04" d="m17.2 8.1 3.1 1.8c1 .6 1 2.1 0 2.7l-3.1 1.8L13.3 12l3.9-3.9z"/><path fill="#34A853" d="M3.6 2.4c.3-.2.7-.2 1.1 0l11.4 6.6-2.8 3L3.6 2.4z"/><path fill="#4285F4" d="M13.3 12l2.8 3-11.4 6.6c-.4.2-.8.2-1.1 0L13.3 12z"/></svg>
          <span className="text-left leading-none">
            <span className="block text-[10px] opacity-70">Disponible sur</span>
            <span className="block text-sm font-semibold">Google Play</span>
          </span>
        </a>
      )}
    </div>
  );
};
